import { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import styles from '../styles/HomePage.module.css';

// ─────────────────────────────────────────────
// HERO SLIDES — swap in your own image paths
// Each object: { src, alt, position }
// position: CSS background-position value e.g. 'center top'
// ─────────────────────────────────────────────
const HERO_SLIDES = [
  {
    src: '/Pictures/Landscape/IMG_4464.jpeg',   // ← people
    alt: 'Grand Tetons',
    position: 'center top',
  },
];

//dump hero slide boxes here to remove it temporarily//
  //{
  //  src: '/Pictures/Places/MKT02235.jpeg',   // ← nice landscape
  //  alt: 'Hot air balloons at sunrise. Mexico',
  //  position: 'center center',
  //},
  //{
  //  src: '/Pictures/Animals/MKT03585.jpeg',   // ← animal/wild
  //  alt: 'Dog days of summer. Fort Funston',
  //  position: 'center center',
  //},


// ─────────────────────────────────────────────
// FEATURED GALLERY — swap in your best 4 shots
// main: the large left image (portrait or landscape)
// thumbs: 4 supporting images (2x2 right grid)
// ─────────────────────────────────────────────
const FEATURED = [
  {
    src: '/Pictures/Featured/MKT01380.jpg',
    alt: 'Featured photograph 1',
    to: '/portraits',
  },
  {
    src: '/Pictures/Featured/MKT02874-5.jpeg',
    alt: 'Featured photograph 2',
    to: '/landscape',
  },
  {
    src: '/Pictures/Featured/MKT01940.jpeg',  /*to change this car photo to something people landscape-orientation*/
    alt: 'Featured photograph 3',
    to: '',
  },
  {
    src: '/Pictures/Wildlife/MKT01607.jpeg',
    alt: 'Featured photograph 4',
    to: '/nature',
  },
];



// Interval between hero crossfades — milliseconds
const SLIDE_INTERVAL = 5000;

export default function HomePage() {
  const [activeSlide, setActiveSlide] = useState(0);
  const intervalRef = useRef(null);

/// Auto-advance once through all slides, then stop
useEffect(() => {
  // If we've already reached the last slide, don't start the interval
  if (activeSlide >= HERO_SLIDES.length - 1) return;

  intervalRef.current = setInterval(() => {
    setActiveSlide(i => {
      const next = i + 1;
      // Stop when we hit the last slide
      if (next >= HERO_SLIDES.length - 1) {
        clearInterval(intervalRef.current);
      }
      return next;
    });
  }, SLIDE_INTERVAL);

  return () => clearInterval(intervalRef.current);
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, []);

  // Manual dot click — also resets the interval
  const goToSlide = (index) => {
    setActiveSlide(index);
    clearInterval(intervalRef.current);
    intervalRef.current = setInterval(() => {
      setActiveSlide(i => (i + 1) % HERO_SLIDES.length);
    }, SLIDE_INTERVAL);
  };

  return (
    <main>

      {/* ── HERO ───────────────────────────────── */}
      <section className={styles.hero} aria-label='Hero slideshow'>

        {/* Photo slides */}
        {HERO_SLIDES.map((slide, i) => (
          <div
            key={slide.src}
            className={`${styles.hero__slide} ${i === activeSlide ? styles['hero__slide--active'] : ''}`}
            style={{
              backgroundImage: `url(${slide.src})`,
              backgroundPosition: slide.position,
            }}
            role='img'
            aria-label={slide.alt}
          />
        ))}

        {/* Slide indicator dots */}
        {HERO_SLIDES.length > 1 && (
          <div className={styles.hero__dots} aria-label='Slide navigation'>
          {HERO_SLIDES.map((_, i) => (
            <button
              key={i}
              className={`${styles.hero__dot} ${i === activeSlide ? styles['hero__dot--active'] : ''}`}
              onClick={() => goToSlide(i)}
              aria-label={`Go to slide ${i + 1}`}
            />
          ))}
        </div>
        )}
      </section>

      {/* ── INTRO STRIP ────────────────────────── */}
      <section className={`${styles.intro} container`}>
        <div className={styles.intro__inner} style={{ flexDirection: 'column', alignItems: 'flex-start' }}>
          <div className='section-header'>
            <p className='label'>Bay Area · Available for bookings</p>
            <h1 className='heading-xl'>
              {/* ← swap your own tagline */}
              Portraits, events, and the moments in between.
            </h1>
          </div>
          <div className={styles.intro__ctas}>
            <Link to='/contact' className='btn'>Book a session →</Link>
            <Link to='/portraits' className='btn--text'>See the gallery →</Link>
            <Link to='/about' className='btn--text'>About the photographer →</Link>
          </div>
        </div>
      </section>

{/* ── FEATURED GALLERY ───────────────────── */}
<section className={`section ${styles.featured}`}>
  <div className='container'>
    <div className='section-header'>
      <p className='label'>Recent works</p>
    </div>

<div className={styles.featured__grid}>
  <Link to={FEATURED[0].to} className={styles.featured__img1}>
    <img src={FEATURED[0].src} alt={FEATURED[0].alt} loading='eager' />
  </Link>

  <Link to={FEATURED[1].to} className={styles.featured__img2}>
    <img src={FEATURED[1].src} alt={FEATURED[1].alt} loading='lazy' />
  </Link>

  <Link to={FEATURED[2].to} className={styles.featured__img3}>
    <img src={FEATURED[2].src} alt={FEATURED[2].alt} loading='lazy' />
  </Link>

  <Link to={FEATURED[3].to} className={styles.featured__img4}>
    <img src={FEATURED[3].src} alt={FEATURED[3].alt} loading='lazy' />
  </Link>
</div>

    <div className={styles.featured__footer}>
      <Link to='/portraits' className='btn--text'>
        View full portfolio →
      </Link>
    </div>
  </div>
</section>

      {/* ── TESTIMONIALS ───────────────────────── */}
      <section className={`section ${styles.testimonials}`}>
        <div className='container'>
          <div className='section-header'>
            <p className='label'>What clients say</p>
          </div>

          <div className={styles.testimonials__grid}>

            <div className={styles.testimonial__card}>
              <p className={styles.testimonial__quote}>
                "Mike was amazing with the photos and spots around campus, and willingness to include all my family as well."
              </p>
              <div className={styles.testimonial__footer}>
                <p className={styles.testimonial__name}>Diego</p>
                <p className={styles.testimonial__context}>Graduation session</p>
              </div>
            </div>

            <div className={styles.testimonial__card}>
              <p className={styles.testimonial__quote}>
                "Thank you so much to Mike for taking these photos. They came out amazing!"
              </p>
              <div className={styles.testimonial__footer}>
                <p className={styles.testimonial__name}>Office of Education & new graduates</p>
                <p className={styles.testimonial__context}>Graduation Reception</p>
              </div>
            </div>

            <div className={styles.testimonial__card}>
              <p className={styles.testimonial__quote}>
                "It was great getting to meet and work with Mike for this event and we are so were so happy with the way his photos turned out."
              </p>
              <div className={styles.testimonial__footer}>
                <p className={styles.testimonial__name}>Lauren</p>
                <p className={styles.testimonial__context}>Times Higher Education Event</p>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* ── SERVICES ───────────────────────────── */}
      <section className={`section section--alt ${styles.services}`}>
        <div className='container'>
          <div className='section-header'>
            <p className='label'>Sessions & coverage</p>
            <h2 className='heading-xl'>Let's create something</h2>
          </div>

          <p className='body-text' style={{
            marginBottom: 'var(--space-sm)',
            color: 'var(--text-secondary)'
          }}>
            Whether it's a portrait session, an event you want documented, or just a question — reach out and let's talk.
          </p>

          <div className={styles.services__grid}>

            <div className={styles.service_card}>
              <p className={styles.service_card__title}>Portrait sessions</p>
              <p className={styles.service_card__desc}>
                People, couples, families, and pets — natural light, on
                location, unhurried. Travel considered.
                {/* ← edit to match your offering */}
              </p>
              <Link to='/contact?type=portrait' className='btn--text'>
                Get a quote →
              </Link>
            </div>

            <div className={styles.service_card}>
              <p className={styles.service_card__title}>Event coverage</p>
              <p className={styles.service_card__desc}>
                Gatherings, milestones, and the moments in between.
                Coverage that stays out of the way and lets the day breathe.
                {/* ← edit to match your event offering */}
              </p>
              <Link to='/contact?type=event' className='btn--text'>
                Check availability →
              </Link>
            </div>

          </div>

          {/* Prints — demoted to a single inquiry line */}
          <p className={styles.services__footnote}>
            Fine art prints from the archive also available —{' '}
            <Link to='/contact?type=print' className='btn--text' style={{ display: 'inline' }}>
              inquire →
            </Link>
          </p>
        </div>
      </section>



    </main>
  );
}
